import React, { Component } from 'react';

import {Dialog, RaisedButton} from 'material-ui';

class ImportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  show(fileinfo, confirm) {
    this.setState({
      open: true,
      fileinfo,
      confirm
    });
  }

  hide() {
    this.setState({
      open: false,
      fileinfo: null
    });
  }

  confirm() {
    this.state.confirm();
    this.setState({
      open: false,
      fileinfo: null
    });
  }

  render() {
    const actions = [
      <RaisedButton label='Cancel' secondary={true} onTouchTap={this.hide.bind(this)}/>,
      <RaisedButton label='Submit' primary={true} onTouchTap={this.confirm.bind(this)}/>
    ];

    const label = (tag, field, process = val => val) =>
      <div>
        <span style={{paddingRight: '10px', paddingBottom: '10px', width: '200px', display: 'inline-block'}}>{tag}</span>
        <span>{process(this.state.fileinfo[field])}</span>
      </div>;

    return <Dialog title='Import Spec File' modal={true} open={this.state.open} actions={actions}>
      {this.state.open ?
        <div>
          {label('Filename:', 'name')}
          {label('Content-Type:', 'type')}
          {label('File Size:', 'size', val => `${(val / 1024).toFixed(3)}kb`)}
          {label('Last Modified Date:', 'lastModifiedDate', val => val.toISOString())}
        </div>
        : null
      }
    </Dialog>;
  }
}

class FilePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
  }
  componentDidMount() {
    this.openDialog = this.openDialog.bind(this);
  }
  onFileSelection(evt) {
    const self = this;
    const files = evt.target.files;

    for (let idx = 0; idx < files.length; ++idx) {
      const file = files[idx];
      this.import_dialog.show(file, info => {
        const reader = new FileReader();
        reader.readAsText(file, 'utf-8');
        reader.onprogress = evt => {
          // progress goes here...
        };
        reader.onload = evt => {
          // on final load, dispatch to onLoad call for this file
          this.props.onLoad(evt.target.result);
        };
      });
    }

    this.setState({
      value: ''
    });
  }
  openDialog() {
    this._dialog && this._dialog.click();
  }
  render() {
    const self = this;
    return <span>
      <input
        ref={e => {self._dialog = e;}}
        type='file'
        style={{display: 'none'}}
        accept='.yaml,.json'
        value={this.state.value}
        onChange={self.onFileSelection.bind(self)}
      />
      <ImportDialog ref={e => {self.import_dialog = e;}}/>
    </span>;
  }
}

export default FilePicker;
